// components/ContactFAQ.jsx
import React, { useState, useEffect, useRef } from 'react'; // Ajouter useRef
import './ContactFAQ.css';
import { HiOutlineMapPin, HiOutlinePhone, HiOutlineEnvelope } from "react-icons/hi2";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import PhoneInput from 'react-phone-number-input';
import { FaWhatsapp } from 'react-icons/fa';
import CallToAction from './CallToAction';

// CORRECTION DES ICÔNES - IMPORTANT !
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
  iconUrl: require('leaflet/dist/images/marker-icon.png').default,
  shadowUrl: require('leaflet/dist/images/marker-shadow.png').default,
});

// Icône rouge personnalisée
const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Composant pour changer le centre
function ChangeMapView({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center, zoom);
  }, [center, zoom, map]);
  return null;
}

const ContactFAQ = () => {
  const [contactForm, setContactForm] = useState({
    nom: '',
    prenoms: '',
    telephone: '',
    service: '',
    email: '',
    message: '',
    honeypot: '',
    website: '',
    formTimestamp: Date.now()
  });

  const [phoneError, setPhoneError] = useState('');
  const [showOtherService, setShowOtherService] = useState(false);
  const [otherService, setOtherService] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [activeLocation, setActiveLocation] = useState('benin');
  const formRef = useRef(null);

  // Données des centres de formation
  const centresFormation = [
    {
      id: 'benin',
      pays: "Bénin",
      // type: "Centre principal",
      tel: "+229 01 58 58 50 50",
      email: "info@inovact.com",
      adresse: "Cotonou, Gbèdjromèdé",
      coordinates: [6.3806623989703, 2.4203159628591093],
      zoom: 13
    },
    {
      id: 'togo',
      pays: "Togo",
      // type: "Centre secondaire",
      tel: "+228 71 64 77 77",
      email: "info@inovact.com",
      adresse: "Lomé, Tokouin",
      coordinates: [6.145178948119016, 1.2017162357743194],
      zoom: 15 // Augmenter le zoom pour mieux voir
    },
  ];

  const handleLocationClick = (locationId) => {
    setActiveLocation(locationId);
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;

    if (name === 'service') {
      setContactForm(prev => ({ ...prev, [name]: value }));
      setShowOtherService(value === 'Autre demande');

      if (value !== 'Autre demande') {
        setOtherService('');
      }
    } else if (name === 'otherService') {
      setOtherService(value);
    } else {
      setContactForm(prev => ({ ...prev, [name]: value }));
    }
  };

  // Gestionnaire pour le téléphone
  const handlePhoneChange = (value) => {
    if (!value) {
      setPhoneError('Le numéro de téléphone est requis');
      setContactForm(prev => ({ ...prev, telephone: '' }));
      return;
    }

    let formattedValue = value;

    if (value.startsWith('0') && !value.startsWith('+')) {
      formattedValue = '+229' + value.substring(1);
    }
    else if (value.startsWith('229') && !value.startsWith('+')) {
      formattedValue = '+' + value;
    }

    if (!formattedValue.startsWith('+')) {
      setPhoneError('Le numéro doit commencer par un indicatif pays (ex: +229)');
      setContactForm(prev => ({ ...prev, telephone: value }));
    } else {
      setPhoneError('');
      setContactForm(prev => ({ ...prev, telephone: formattedValue }));
    }
  };

  // Ajoutez ces states avec vos autres states (contactForm, isSubmitting, etc.)
  const [detectedCountry, setDetectedCountry] = useState('BJ');
  const [isDetectingCountry, setIsDetectingCountry] = useState(true);

  // Ajoutez cet useEffect pour détecter le pays au chargement
 useEffect(() => {
  const detectCountry = async () => {
    try {
      // ipapi.co/country/ retourne du TEXTE brut, pas du JSON
      const response = await fetch('https://ipapi.co/country/');
      const countryCode = await response.text();  // ← .text() pas .json()
      
      // Nettoie le code pays (supprime les espaces, retours à la ligne)
      const cleanCode = countryCode.trim();
      
      if (cleanCode && cleanCode.length === 2) {
        setDetectedCountry(cleanCode);
        // console.log(`Pays détecté: ${cleanCode}`);
      } else {
        // console.warn('Code pays invalide:', cleanCode);
        setDetectedCountry('BJ'); // Fallback
      }
    } catch (error) {
      // console.warn('Erreur détection:', error);
      setDetectedCountry('BJ');
    } finally {
      setIsDetectingCountry(false);
    }
  };
  
  detectCountry();
}, []);

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    // Honeypot validation
    if (contactForm.honeypot.trim() !== '') {
      console.log('Bot détecté via honeypot principal');
      setSubmitSuccess(true);
      setSubmitError('');
      setShowOtherService(false);
      setOtherService('');

      setContactForm({
        nom: '',
        prenoms: '',
        telephone: '',
        service: '',
        email: '',
        message: '',
        honeypot: '',
        website: '',
        formTimestamp: Date.now()
      });

      setTimeout(() => setSubmitSuccess(false), 5000);
      return;
    }

    if (contactForm.website.trim() !== '') {
      console.log('Bot détecté via champ website');
      setSubmitSuccess(true);
      setSubmitError('');
      setShowOtherService(false);
      setOtherService('');

      setContactForm({
        nom: '',
        prenoms: '',
        telephone: '',
        service: '',
        email: '',
        message: '',
        honeypot: '',
        website: '',
        formTimestamp: Date.now()
      });

      setTimeout(() => setSubmitSuccess(false), 5000);
      return;
    }

    const timeElapsed = Date.now() - contactForm.formTimestamp;
    if (timeElapsed < 2000) {
      console.log('Bot détecté: formulaire rempli trop rapidement');
      setSubmitError('Veuillez prendre le temps de remplir le formulaire correctement.');
      return;
    }

    // Validation du téléphone
    if (!contactForm.telephone || !contactForm.telephone.startsWith('+')) {
      setPhoneError('Veuillez entrer un numéro de téléphone valide avec indicatif pays');
      setSubmitError('Veuillez entrer un numéro de téléphone valide avec indicatif pays');
      return;
    }

    // Construire le service final
    let finalService = contactForm.service;
    if (contactForm.service === 'Autre demande' && otherService.trim() !== '') {
      finalService = otherService;
    }

    if (!contactForm.nom || !contactForm.email || !contactForm.message || !contactForm.service) {
      setSubmitError('Veuillez remplir tous les champs obligatoires (*).');
      return;
    }

    if (contactForm.service === 'Autre demande' && otherService.trim() === '') {
      setSubmitError('Veuillez saisir le service que vous souhaitez contacter.');
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(contactForm.email)) {
      setSubmitError('Veuillez entrer une adresse email valide.');
      return;
    }

    setSubmitError('');
    setIsSubmitting(true);

    try {
      const submissionData = {
        nom: contactForm.nom,
        prenoms: contactForm.prenoms,
        telephone: contactForm.telephone.replace(/\s/g, ''),  // Ajout du téléphone
        email: contactForm.email,
        service: finalService,
        message: contactForm.message,
        website: contactForm.website,
        honeypot: contactForm.honeypot,
        submit_time: Math.floor(Date.now() / 1000)
      };

      console.log('Envoi des données au backend:', submissionData);

      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await fetch(`${apiUrl}/envoyer-mail-landingpage/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submissionData),
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitSuccess(true);
        setSubmitError('');
        setShowOtherService(false);
        setOtherService('');
        setPhoneError('');

        setContactForm({
          nom: '',
          prenoms: '',
          telephone: '',
          service: '',
          email: '',
          message: '',
          honeypot: '',
          website: '',
          formTimestamp: Date.now()
        });

        setTimeout(() => setSubmitSuccess(false), 5000);

      } else {
        setSubmitError(result.error || 'Erreur lors de l\'envoi du message. Veuillez réessayer.');
      }

    } catch (error) {
      console.error('Erreur de connexion:', error);
      setSubmitError('Erreur de connexion au serveur. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const activeCentre = centresFormation.find(centre => centre.id === activeLocation);

  // Fonction pour scroller vers le formulaire
  const scrollToContactForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  // Fonction pour scroller vers le formulaire (appelable depuis l'URL)
  useEffect(() => {
    // Vérifier si l'URL contient un hash #form
    if (window.location.hash === '#form' || window.location.search.includes('scrollTo=form')) {
      // setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      // }, 100);
    }
  }, []);

  // Numéro de téléphone au format international (sans le +)
  const phoneNumber = "2290158585050";

  // Message pré-défini (optionnel)
  const defaultMessage = "Bonjour, je souhaite obtenir plus d'informations sur vos services.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  const handleClick = () => {
    window.open(whatsappUrl, '_blank');
  };

  return (

    <>

     

      <section className="section contact-faq">

       <CallToAction
        title="Prêt à collaborer avec nous ?"
        button1Text="Ecrire WhatsApp"
        button2Text="Demander RDV"
        onButton1Click={() => window.open('https://wa.me/2290158585050', '_blank')}
        onButton2Click={scrollToContactForm}
      // button1Icon={<FaWhatsapp />}
      />

        <div className="contenir">
          <h3 className="section-title">Un doute ou une question ? Contactez nous !</h3>
          {/* <p className="section-subtitle">
            Notre équipe est à votre disposition pour répondre à toutes vos questions et préoccupations.
          </p> */}

          <div className="contact-container">
            {/* SECTION GAUCHE : Informations des centres */}
            <div className="contact-informations">
              {/* Sous-titre ajouté en première position */}
              <div className="centres-title-wrapper">
                <p className="section-subtitle">
                  Notre équipe est à votre disposition pour répondre à toutes vos questions et préoccupations.
                </p>
                {/* <h3 className="centres-sous-titre">Nos Centres</h3> */}
              </div>

              {/* Liste des centres */}
              <div className="info-container">
                {centresFormation.map((info, index) => (
                  <React.Fragment key={info.id}>
                    <div className="info-section">
                      <div className="info-content">
                        <h4>{info.pays}</h4>
                        {/* <span className="small">{info.type}</span> */}
                        <p><HiOutlineMapPin /> {info.adresse}</p>
                        <p><HiOutlinePhone /> {info.tel}</p>
                        <p><HiOutlineEnvelope /> {info.email}</p>
                      </div>
                    </div>

                    {index < centresFormation.length - 1 && (
                      <div className="vertical-divider"></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* SECTION DROITE : Formulaire */}
            <div className="contact-form-section" id="contact" ref={formRef}>
              {/* Titre visible uniquement sur mobile */}
              <div className="mobile-contact-title">
                <h3>Contactez-nous</h3>
              </div>

              <form className="contact-form" onSubmit={handleContactSubmit}>
                {/* Champs honeypot (invisibles) */}
                <div style={{
                  position: 'absolute',
                  left: '-9999px',
                  top: '-9999px',
                  opacity: 0,
                  height: 0,
                  width: 0,
                  overflow: 'hidden',
                  pointerEvents: 'none'
                }}>
                  <label htmlFor="website-field" style={{ display: 'none' }}>
                    Ne pas remplir ce champ
                  </label>
                  <input
                    type="text"
                    id="website-field"
                    name="website"
                    value={contactForm.website}
                    onChange={handleContactChange}
                    autoComplete="off"
                    tabIndex="-1"
                    aria-hidden="true"
                    placeholder="Ne pas remplir"
                  />
                </div>

                <div style={{ display: 'none' }}>
                  <label htmlFor="honeypot">Ne pas remplir ce champ</label>
                  <input
                    type="text"
                    id="honeypot"
                    name="honeypot"
                    value={contactForm.honeypot}
                    onChange={handleContactChange}
                    tabIndex="-1"
                    autoComplete="off"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="contact-nom">NOM *</label>
                    <input
                      type="text"
                      id="contact-nom"
                      name="nom"
                      placeholder="NOM"
                      value={contactForm.nom}
                      onChange={handleContactChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="contact-prenoms">PRÉNOMS *</label>
                    <input
                      type="text"
                      id="contact-prenoms"
                      name="prenoms"
                      placeholder="PRÉNOMS"
                      value={contactForm.prenoms}
                      onChange={handleContactChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                {/* Ajout de la ligne Email et Téléphone côte à côte */}
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="contact-email">EMAIL *</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      placeholder="EMAIL"
                      value={contactForm.email}
                      onChange={handleContactChange}
                      required
                      disabled={isSubmitting}
                      pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                      title="Veuillez entrer une adresse email valide (ex: nom@domaine.com)"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="contact-telephone">TÉLÉPHONE *</label>
                    <PhoneInput
                      international
                      defaultCountry={detectedCountry}
                      value={contactForm.telephone}
                      onChange={handlePhoneChange}
                      required
                      // countries={['BJ', 'TG', 'CI', 'SN', 'FR']}
                      placeholder="+229 XX XX XX XX"
                      disabled={isSubmitting || isDetectingCountry}
                      style={{ height: '50px' }}

                    />
                    {phoneError && (
                      <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>{phoneError}</div>
                    )}
                  </div>
                </div>

                {/* Champ "Autre service" */}
                {showOtherService && (
                  <div className="form-group">
                    <label htmlFor="contact-other-service">Veuillez préciser le service *</label>
                    <input
                      type="text"
                      id="contact-other-service"
                      name="otherService"
                      placeholder="Saisissez le service que vous souhaitez contacter"
                      value={otherService}
                      onChange={handleContactChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="contact-service">SERVICE *</label>
                  <select
                    id="contact-service"
                    name="service"
                    value={contactForm.service}
                    onChange={handleContactChange}
                    required
                    disabled={isSubmitting}
                  >
                    <option value="">Sélectionnez un service...</option>
                    <option value="Parler à un commercial">Discuter avec un commercial</option>
                    <option value="Discuter avec un coach">Discuter avec un coach</option>
                    <option value="Informations sur PMP">Discuter avec un technicien</option>
                    <option value="Autre demande">Autres</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="contact-message">VOTRE MESSAGE *</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows="2"
                    placeholder="VOTRE MESSAGE..."
                    value={contactForm.message}
                    onChange={handleContactChange}
                    required
                    disabled={isSubmitting}
                  ></textarea>
                </div>

                {submitSuccess && (
                  <div className="alert alert-success">
                    ✅ Votre message a été envoyé avec succès! Notre équipe vous répondra dans les plus brefs délais.
                  </div>
                )}

                {submitError && (
                  <div className="alert alert-error">
                    ❌ {submitError}
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-large btn-secondary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner"></span>
                      ENVOI EN COURS...
                    </>
                  ) : (
                    'ENVOYER'
                  )}
                </button>
              </form>
            </div>
          </div>

        </div>


        <style jsx>{`
        /* Layout 50/50 pour desktop : Infos à gauche, formulaire à droite */
        .section-spacing {
          width: 100%
        }

        .contact-container {
          display: flex;
          gap: 3rem;
          width: 100%
          {/* margin-top: 3rem; */}
        }
        
        .contact-informations {
          flex: 1;
          width: 50%;
        }
        
        .contact-form-section {
          flex: 1;
          width: 50%;
        }
        
        /* Sous-titre "Nos Centres" */
        .centres-title-wrapper {
          margin-top: 2rem;
          margin-bottom: 2rem;
        }
        
        .centres-sous-titre {
          font-size: 1.8rem;
          font-weight: 700;
          color: #0a3764;
          margin: 0;
          padding-bottom: 0.5rem;
          position: relative;
        }
        
        .centres-sous-titre::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 60px;
          height: 3px;
          background-color: #1a3c5e;
          border-radius: 2px;
        }
        
        /* Conteneur pour les infos horizontales sur desktop, vertical sur mobile */
        .info-container {
          // display: flex;
          gap: 2rem;
          // margin-bottom: 1.5rem;
        }
        
        .info-section {
          flex: 1;
          padding: 0;
          position: relative;
          display: flex;
          flex-direction: column;
        }
        
        .info-content {
          padding: 1.5rem;
          background: #dadada;
          border-radius: 12px;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .info-content:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }
        
        .vertical-divider {
          width: 1px;
          background-color: rgba(82, 82, 82, 0.2);
          margin: 1.5rem 0;
          height: auto;
          align-self: stretch;
        }
        
        /* Titre mobile "Contactez-nous" */
        .mobile-contact-title {
          display: none;
        }
        
        /* Alertes */
        .alert {
          padding: 12px 16px;
          border-radius: 6px;
          margin-bottom: 20px;
          font-size: 0.95rem;
        }
        
        .alert-success {
          background-color: #d4edda;
          color: #155724;
          border: 1px solid #c3e6cb;
        }
        
        .alert-error {
          background-color: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
        }
        
        .spinner {
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: #fff;
          animation: spin 1s ease-in-out infinite;
          margin-right: 8px;
        }
        
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        
        button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        
        input:disabled,
        select:disabled,
        textarea:disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
        }
        
        /* Responsive mobile */
        @media (max-width: 768px) {
          .contact-container {
            flex-direction: column;
            gap: 2rem;
          }
          
          .contact-informations,
          .contact-form-section {
            width: 100%;
          }
          
          /* Afficher le titre "Contactez-nous" sur mobile dans la section formulaire */
          .mobile-contact-title {
            display: block;
            margin-bottom: 1.5rem;
          }
          
          .mobile-contact-title h3 {
            color: #0a3764;
            font-size: 1.8rem;
            text-align: left;
            margin: 0;
            font-weight: 600;
            position: relative;
            padding-bottom: 0.5rem;
          }
          
          .mobile-contact-title h3::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 60px;
            height: 3px;
            background-color: #1a3c5e;
            border-radius: 2px;
          }
          
          .info-container {
            flex-direction: column;
            gap: 1rem;
          }
          
          .info-content {
            padding: 1rem;
          }
          
          .vertical-divider {
            width: 100%;
            height: 1px;
            margin: 0;
          }
        }
      `}</style>
      </section>
    </>

  );
};

export default ContactFAQ;